import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  previousDateWrapper: {
    paddingBottom: theme.spacing(5),
  },
  serviceEndDateWrapper: {
    paddingBottom: theme.spacing(3),
  },
  title: {
    color: theme.palette.labraText.primary,
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
  },
  value: {
    color: theme.palette.textField.dark,
    fontSize: '16px',
    lineHeight: '24px',
    paddingTop: theme.spacing(1),
  },
  subValue: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    lineHeight: '20px',
    paddingTop: theme.spacing(1),
  },
  datePicker: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
  },
}))
